import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { EntityManager } from "./EntityManager";
import { MongoEntityManager } from "./MongoEntityManager";
import { SqljsEntityManager } from "./SqljsEntityManager";
/**
 * Helps to create entity managers.
 */
export var EntityManagerFactory = /*#__PURE__*/function () {
  function EntityManagerFactory() {
    _classCallCheck(this, EntityManagerFactory);
  }
  _createClass(EntityManagerFactory, [{
    key: "create",
    value:
    /**
     * Creates a new entity manager depend on a given connection's driver.
     */
    function create(connection, queryRunner) {
      if (connection.driver.options.type === "mongodb") return new MongoEntityManager(connection);
      if (connection.driver.options.type === "sqljs") return new SqljsEntityManager(connection, queryRunner);
      return new EntityManager(connection, queryRunner);
    }
  }]);
  return EntityManagerFactory;
}();